import { render, staticRenderFns } from "./RespondsHeader.vue?vue&type=template&id=b384b598"
import script from "./RespondsHeader.vue?vue&type=script&lang=ts"
export * from "./RespondsHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports